import { RECEIPT_STATUS_OPTIONS } from '../constants/post';

const RECEIPT_FIELDS = [
  { name: 'receivedCompany', label: '접수 업체', required: true, placeholder: '신호, 에이스, 지케이 등' },
  { name: 'receivedBy', label: '접수자', required: true, placeholder: '접수자 이름' },
  { name: 'receiptStatus', label: '접수 상태', type: 'select' },
  { name: 'receivedAt', label: '접수 시간', type: 'datetime-local', required: true },
];

const RECEIPT_FIELDS_EDIT = [
  { name: 'receivedCompany', label: '접수 업체', required: true, placeholder: '신호, 에이스, 지케이 등' },
  { name: 'receivedBy', label: '접수자', required: true, placeholder: '접수자 이름' },
  { name: 'receivedAt', label: '접수 시간', type: 'datetime-local', required: true },
];

const REQUESTER_FIELDS = [
  { name: 'proposer', label: '민원인', required: true, placeholder: '민원인 이름' },
  { name: 'proposerPhoneNumber', label: '민원인 전화번호', type: 'text', required: true, placeholder: '01012345678' },
  { name: 'possessor', label: '설비 소유자', required: true, placeholder: '설비 소유자 이름' },
  { name: 'possessorPhoneNumber', label: '설비 소유자 전화번호', type: 'text', required: true, placeholder: '01012345678' },
  { name: 'address', label: '주소', required: true },
  { name: 'detailAddress', label: '상세 주소' },
  { name: 'issueDescription', label: '민원 내용', type: 'textarea', rows: 4, required: true, wide: true },
];

const INSTALLATION_FIELDS = [
  { name: 'installationYear', label: '설치연도' },
  { name: 'businessName', label: '사업명' },
  { name: 'managementNumber', label: '관리번호' },
  { name: 'installationCompany', label: '시공 업체' },
  { name: 'contractorManager', label: '시공 업체 담당자' },
  { name: 'contractorPhoneNumber', label: '시공 업체 담당자 전화번호', type: 'text' },
  { name: 'capacity', label: '설비 용량(kw)' },
  { name: 'moduleManufacturer', label: '모듈 제조사' },
  { name: 'moduleModelName', label: '모듈 모델명' },
  { name: 'moduleQuantity', label: '모듈 수량' },
  { name: 'inverterManufacturer', label: '인버터 제조사' },
  { name: 'inverterModelName', label: '인버터 모델명' },
  { name: 'ratedVoltage', label: '정격전압(V)' },
  { name: 'inverterQuantity', label: '인버터 수량' },
  { name: 'inverterCapacity', label: '인버터 용량(kw)' },
  { name: 'junctionBoxYn', label: '접속반 유무', type: 'yn-select' },
];

const PROCESSING_FIELDS = [
  { name: 'processedBy', label: '접수 처리자' },
  { name: 'processedAt', label: '조치 완료 시간', type: 'datetime-local' },
  { name: 'resolution', label: '고장 원인/조치사항', type: 'textarea', rows: 7, wide: true },
];

const PROCESSING_FIELDS_EDIT = [
  { name: 'processedBy', label: '접수 처리자' },
  { name: 'receiptStatus', label: '처리 상태', type: 'select' },
  { name: 'processedAt', label: '조치 완료 시간', type: 'datetime-local' },
  { name: 'resolution', label: '고장 원인/조치사항', type: 'textarea', rows: 7, wide: true },
];

const renderLabel = (field) => (
  <span className="field-label">
    {field.label}
    {field.required ? <small className="required-text">필수</small> : null}
  </span>
);

const renderField = (field, form, onChange) => {
  const className = field.wide ? 'field field-wide' : 'field';

  if (field.type === 'textarea') {
    return (
      <label key={field.name} className={className}>
        {renderLabel(field)}
        <textarea
          name={field.name}
          value={form[field.name] ?? ''}
          required={field.required}
          rows={field.rows ?? 3}
          placeholder={field.placeholder}
          onChange={onChange}
        />
      </label>
    );
  }

  if (field.type === 'select') {
    return (
      <label key={field.name} className={className}>
        {renderLabel(field)}
        <select name={field.name} value={form[field.name]} onChange={onChange}>
          {RECEIPT_STATUS_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    );
  }

  if (field.type === 'yn-select') {
    return (
      <label key={field.name} className={className}>
        {renderLabel(field)}
        <select name={field.name} value={form[field.name] ?? ''} onChange={onChange}>
          <option value="" />
          <option value="Y">Y</option>
          <option value="N">N</option>
        </select>
      </label>
    );
  }

  return (
    <label key={field.name} className={className}>
      {renderLabel(field)}
      <input
        type={field.type ?? 'text'}
        name={field.name}
        value={form[field.name] ?? ''}
        required={field.required}
        placeholder={field.placeholder}
        onChange={onChange}
      />
    </label>
  );
};

const renderSection = (title, fields, form, onChange) => (
  <section className="form-section">
    <h3>{title}</h3>
    <div className="form-grid">{fields.map((field) => renderField(field, form, onChange))}</div>
  </section>
);

function PostForm({ form, onChange, mode = 'create' }) {
  const isEditMode = mode === 'edit';
  const receiptFields = isEditMode ? RECEIPT_FIELDS_EDIT : RECEIPT_FIELDS;
  const processingFields = isEditMode ? PROCESSING_FIELDS_EDIT : PROCESSING_FIELDS;

  return (
    <div className="form-sections">
      {renderSection('접수 정보', receiptFields, form, onChange)}
      {renderSection('민원인/설비 정보', REQUESTER_FIELDS, form, onChange)}
      {renderSection('설치 정보', INSTALLATION_FIELDS, form, onChange)}
      {renderSection('처리 정보', processingFields, form, onChange)}
    </div>
  );
}

export default PostForm;
